import { GetServerSidePropsContext } from 'next'
import { setCookie } from 'nookies'
import { CheckoutFlow } from '../../flow/type'

/**
 * Cookie name for storing the current checkout flow
 */
export const FLOW_COOKIE_NAME = 'apt-flow-name'

/**
 * Enum values for flow cookie
 */
export enum FlowCookieValue {
  Default = 'default',
  ApplePaylater = 'apple-paylater',
}

/**
 * Mapping between CheckoutFlow type and FlowCookieValue enum
 */
const FLOW_TO_COOKIE_VALUE: Record<CheckoutFlow, FlowCookieValue> = {
  default: FlowCookieValue.Default,
  'apple-paylater': FlowCookieValue.ApplePaylater,
}

/**
 * Mapping between FlowCookieValue enum and CheckoutFlow type
 */
const COOKIE_VALUE_TO_FLOW: Record<FlowCookieValue, CheckoutFlow> = {
  [FlowCookieValue.Default]: 'default',
  [FlowCookieValue.ApplePaylater]: 'apple-paylater',
}

/**
 * Gets the flow from the cookie
 */
export const getFlowFromCookie = (context: GetServerSidePropsContext): CheckoutFlow | null => {
  const flowCookie = context.req.cookies[FLOW_COOKIE_NAME] as FlowCookieValue | undefined

  if (!flowCookie) {
    return null
  }

  return COOKIE_VALUE_TO_FLOW[flowCookie] ?? null
}

/**
 * Sets the flow cookie in the response
 */
export const setFlowCookie = (context: GetServerSidePropsContext, flow: CheckoutFlow): void => {
  const cookieValue = FLOW_TO_COOKIE_VALUE[flow]

  // Appends rather than assigning Set-Cookie directly: this runs after the LaunchDarkly key and
  // theme cookies are written, and a scalar setHeader would drop them.
  setCookie(context, FLOW_COOKIE_NAME, cookieValue, {
    maxAge: 60 * 60, // 1 hour
    secure: process.env.NODE_ENV === 'production',
    path: '/',
    sameSite: 'lax',
  })
}
